import React, { useEffect, useState } from 'react'
import { withOidcSecure } from '@axa-fr/react-oidc'
import { height, width } from "../../CustomComponents/DynamicCard/DynamicCardStyles";
import { addLineBreaks } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import HomeLayout from '../../Layout/HomeLayout';
import LeftBar from '../../CustomComponents/DynamicComponent/LeftBar';
//import DynamicCard from '../../CustomComponents/DynamicComponent/DynamicCard.js';
import DynamicCard from '../../CustomComponents/DynamicCard';
import HelpIcon from '../../../assets/images/illo-help (1).png'
import FindATM from '../../../assets/images/illo-ATM.png'
import { useNavigate } from 'react-router';
import FooterContent from '../../CustomComponents/Footer';
import { KudzuHelpSidebar } from '../../../utils';
import Loader from '../../CustomComponents/Loader';
import RightArrow from '../../../assets/images/Caret S.png'
import { Link } from 'react-router-dom';
import { appTheme, showKudzuPlusPrompt } from '../../../helpers/utils/Utils';
import atmImage from '../../../assets/kudzu-plus-images/ATM.png';
import CustomModalPlus from '../../../kudzu_plus/helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../../../kudzu_plus/components/membershipEnrollmentScreens';

import { useLocation } from 'react-router';
import logFirebaseEvents from '../../LogFirebaseEvents';
import { PAID_PROMO_KEY } from '../../../network/URLConstants';
import Cookies from 'js-cookie';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const KudzuHelp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentpath = useLocation()
    // const [isLoading, setIsLoading] = useState(false); 

    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk  modal-title lg:text-[14px] md:text-[13px] sm:text-[11px] text-[12px] font-normal cursor-pointer pointer-events-none";
    const [modelImage, setModelImage] = useState('')
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [toNavigate, setToNavigate] = useState('');
    const [isBorderNone, setisBorderNone] = useState(true);
    const [showErrorImg, setshowErrorImg] = useState(false);

    const [showPlusModal, setShowPlusModal] = useState(false);
    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const [isHelpDismissed, setIsHelpDismissed] = useState(false);
    const isSmiOneIsTrue = useSelector(state => state.smiOneAccountTrue);


    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";

    const subMenuList = [
        {
            name: t("helpfaq"),
            url: "/Help/FAQ"
        },
        {
            name: t("findATMBtn"),
            url: "/Help/FindATM"
        },
        {
            name: t("conatctus"),
            url: "/Help/ContactUs"
        },
    ]

    const helpListItems = 'font-hanken-grotesk font-[600] lg:text-[16px] md:text-[14px] sm:text-[14px] text-[15px] leading-[20px] md:font-[700] md:leading-[16px] lg:leading-[16px] text-[#FEFAEE]'
    const [isLoading, setIsLoading] = useState(false);

    const cards = useSelector(state => JSON.parse(state.userCards));
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const isShowKudzuPlusPrompt = showKudzuPlusPrompt(loggedResponse);
    const appThemeData = appTheme(kudzuPlusTrue);
    useDocumentTitle(t('page_title_kudzu_help'));
    const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);


    const helpChildren1 = () => {
        return (
            <>
                <div className="sm:flex block flex-row justify-between md:pt-20 pt-16 sm:pt-10 lg:pb-36 md:pb-32 sm:pb-20 pb-5 md:mx-0 mx-4">
                    {/* <div className="sm:flex flex-row justify-between md:pt-20 pt-16 lg:pb-40 md:pb-36 sm:pb-28 sm:mx-0 mx-4"> */}
                    <div className='flex flex-col lg:w-[406px] md:w-[321px] sm:w-[263px] w-full'>
                        <p className="text-[var(--text-clr-transactions)] sm:text-[var(--help-footer-highlight-text)] font-normal
                        leading-[30px] md:leading-[24px] lg:text-[32px]
                         md:text-[28px] sm:text-[18px] text-[25px] lg:leading-[38px] 
                         font-serif-pro">{t("helpCardHeading")}</p>

                        {/* <p className='font-hanken-grotesk font-[500]
                         lg:leading-[30px] md:leading-[26px] sm:leading-[20px] leading-[25px] lg:text-[20px] md:text-[16px]
                         sm:text-[13px] text-[16px] md:mt-6 mt-4
                         text-[#0C4437]'>{t("helpsubHeading")}</p> */}

                        <p className='font-hanken-grotesk font-[400] sm:font-[500] md:leading-[30px] 
                        sm:leading-[20px] leading-[24px]  md:text-[20px] sm:text-[12px] 
                         text-[16px] md:mt-6 mt-4 text-[var(--text-clr-transactions)] sm:text-[var(--help-footer-subheading)]
                        '>{t("helpsubHeading")}</p>
                    </div>
                    <div>
                        <img src={appThemeData.helpIcon} alt="help" className='sm:block hidden lg:w-[120px] lg:h-[120px]
                         md:w-[100px] md:h-[100px] w-[92px] h-[92px]' />
                    </div>
                </div>
                <div className='sm:hidden block px-4 py-10'>
                    {/* <div className='w-full'>
                        <div class="sm:flex w-full md:mb-[3rem] sm:mb-8">
                            <div class="sm:w-[50%] w-full sm:mb-0 mb-5">
                                <div class="sm:w-[90%] w-full md:pb-[1.5rem] 
                                pb-[1.3rem] flex justify-between items-center 
                                border-b-[3px] border-[#E7E4DC] cursor-pointer border-opacity-[75%]">
                                    <p class="font-[600] text-[#262B3A] lg:text-[16px] 
                                    md:text-[15px] sm:text-[11px] text-[14px] leading-[16px]
                                     font-hanken-grotesk">About Kudzu</p><p>
                                        <img src={RightArrow}
                                            class="w-[7px] mr-[10px]" alt="" /></p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {subMenuList.map((item, index) => {
                        return (
                            <Link to={item.url} key={index}>
                                <div className='w-full'>
                                    <div class="sm:flex w-full md:mb-[3rem] sm:mb-8">
                                        <div class="sm:w-[50%] w-full sm:mb-0 mb-5">
                                            <div
                                                class="sm:w-[90%] w-full md:pb-[1.5rem] pb-[1.3rem] flex justify-between items-center border-b-[3px] border-[var(--help-footer-border)] cursor-pointer border-opacity-[75%]"
                                                onClick={() => {
                                                    navigate(item.url);
                                                }}
                                            >
                                                <p class="font-[600] text-[var(--text-clr-transactions)] lg:text-[16px] md:text-[15px] sm:text-[11px] text-[14px] leading-[16px] font-hanken-grotesk">{item.name}</p>
                                                <p>
                                                    <img src={appThemeData.rightArrow} class="w-[7px] mr-[10px]" alt="" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )
                    })}

                </div>
            </>
        )
    }
    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)// gradient button for popup
        setLargeImage(largeImage)
    }

    const closeModelPlus = () => {
        logFirebaseEvents("Help", "Kudzu_Plus_Closed", "Kudzu_Plus_Closed", "", "");
        setShowPlusModal(false);
        setShowCarouselScreensShow(false);
    }
    const onAcptBtnClickPlusModal = () => {
        logFirebaseEvents("Help", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
        setShowPlusModal(false)
        const currentPath = { currentPathFromStore: currentpath.pathname };
        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
        setShowCarouselScreensShow((prev) => !prev);
        const data = { kudzuFlowFrom: "fromHelp" };
        dispatch({ type: 'KUDZU_PLUS_FROM', payload: data })
    }

    const onCancelBtnClickPlusModal = () => {
        logFirebaseEvents("Help", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
        setShowPlusModal(false)
    }

    useEffect(() => {
        const helpDismisseGet = `HelpDismiss${cards.find(card => card.AccountTypeBit63 === 64).CardKey}`;
        const HelpShown = Cookies.get(helpDismisseGet); 
        setIsHelpDismissed(HelpShown); 
    }, []);

    const handleDismiss = () => { 
        const HelpDismiss = `HelpDismiss${cards.find(card => card.AccountTypeBit63 === 64).CardKey}`; 
        Cookies.set(HelpDismiss, 'true', { expires: 1825 });
        setIsHelpDismissed(true); 
    };

    const kuzuPlusLearnMoreFooterContent = () => {
        return (
            <FooterContent
                highlightText={(t("Network_ATM_Fees_Save_On"))}
                isShowDismiss={true}
                isSubHeadingMiddla={false}
                isShowDismissbackgroundColor={true}
                subHeaderText={(t("Free_out-of-network"))}
                content ={addLineBreaks(t("Help_Footer_Main_Content"))}
                isHelp={true}
                image={atmImage} type="kudzuPlusLearnMore"
                buttonEnabled={true} buttonText={t("learn_more")} isSpace={false}
                subHeaderTextColor={'#ffffff'}
                isSubHeaderTextSize={'18px'}
                isContentTextSize={'14px'}
                IsContentGap={'pt-5'}
                isContentColor={'#ffffff'}
                 buttonCancelText={t('dismiss')}
                footerBtnActionCancelKudzu={handleDismiss}
                footerBtnAction={() => {
                    logFirebaseEvents("Help", "Learn_More_Clicked", "Learn_More_Clicked", "", "");
                    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
                    setShowCarouselScreensShow(false);
                    //showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", t('first_three_months_charged_automatically'), true, '', false, false, true, true);
                    showAlertModalPlus(true,
                        promoKey == PAID_PROMO_KEY ? "" : t("thanks"),
                        promoKey == PAID_PROMO_KEY ? addLineBreaks(t('paid_access_exclusive_fature_and_benfits_when_you_join_kudzu_plus')) : t("Try_a_Kudzu+_membership_for_three_months"),
                        "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A",
                        promoKey == PAID_PROMO_KEY ? t('monthly_memebership_fee_will_be_automatically_deducted') : t('first_three_months_charged_automatically'),
                        true, '', false, false, true, true);
                }}
                borderDirection={'odd'} />
        )

    }

    const footerContent = () => {
        return (
            <FooterContent highlightText={t("findNoFeeATM")}
                subHeaderText={isSmiOneIsTrue ? t("Get_nocost_withdrawals") : t("findATMSubHeading")}
                type={"FindATM"}
                isSubheadingwidth={false}
                image={appThemeData.findATMIcon}
                buttonEnabled={true}
                buttonText={t("findATMBtn")}
                highlightTextColor={"#2965FB"}
                footerBtnAction={() => navigate("/Help/Kudzu/FindATM")} />
        )
    }

    return (
        <>
            <HomeLayout>
                <KudzuHelpSidebar isSubMenu={true} HelpselectedIndex={0} />
                {showCarouselScreenShow &&
                    <MemnershipEnrollmentScreens />}

                <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>

                <div className='flex flex-col md:w-[860px] sm:w-[464px] 
            w-[100%] animate__animated animate__fadeInRight '>
                    <DynamicCard
                        header={true}
                        CardRadius={true}
                        cardWidth={width.homeCard}
                        HeaderRadius={true}
                        HeaderContent={false}
                        isWhite={appThemeData.isWhiteBgForCard}
                        isDarkForKudzu={appThemeData.isDarkBgForCard}
                        footer={true}>
                        {helpChildren1()}
                    </DynamicCard>
                    {footerContent()}
                    {(!kudzuPlusTrue && isShowKudzuPlusPrompt && !isHelpDismissed) && kuzuPlusLearnMoreFooterContent()}
                </div>
                <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
                    image={modelImage}
                    carousel={carousel}
                    summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
                    isBorderNone={isBorderNone}
                    highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
                    subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                    btn1Exists={btn1Exists}
                    btn2Exists={btn2Exists}
                    btn1Text={btn1Text}
                    btn1BgColor={btn1BgColor}
                    btn2Text={btn2Text}
                    opacityLow={opacityValueLow}
                    defaultCornerRadius={false}
                    btn1TypeAcpt={btn1TypeAcpt}
                    onAcptBtnClick={onAcptBtnClickPlusModal}
                    onCancelBtnClick={onCancelBtnClickPlusModal}
                    gradientButton={gradientButton}
                    largeImage={largeImage}
                    btn2TextColor={'#779CE5'}
                />
            </HomeLayout>
            {isLoading && <Loader />}
        </>

    )
}

export default withOidcSecure(KudzuHelp)